import { PharmacistLayout } from "@/components/layout/pharmacist-layout";
import { CpdModuleReaderContent } from "@/components/cpd/cpd-module-reader";

export default function PharmacistLearnModule() {
  return (
    <PharmacistLayout title="CPD Learning Hub">
      <CpdModuleReaderContent listPath="/pharmacist/learn" />
    </PharmacistLayout>
  );
}
